<template>
    <div v-if="props.form && props.options">
        <VueDrawingCanvas
                ref="VueDrawingCanvas"
                v-model:image="props.form.base64"
                :stroke-type="props.options.strokeType"
                :fill-shape="props.options.fillShape"
                :eraser="props.options.eraser"
                :lineWidth="props.options.line"
                :color="props.options.color"
                :background-color="props.options.backgroundColor"
                :background-image="props.options.backgroundImage"
                :watermark="props.options.watermark"
                :saveAs="props.options.saveAs"
                :styles="props.options.styles"
                :lock="props.options.lock || props.viewOnly"
                width="450"
                height="250"
        ></VueDrawingCanvas>

        <div class="button-container">
            <button type="button" class="mx-1" @click="VueDrawingCanvas.undo">
                Undo
            </button>
            <button type="button" class="mx-1" @click="VueDrawingCanvas.redo">
                Redo
            </button>
            <button type="button" class="mx-1" @click="VueDrawingCanvas.redraw">
                Refresh
            </button>
            <button type="button" class="mx-1" @click="() => {
                props.options.backgroundImage = null;
                VueDrawingCanvas.reset();
            }">
                Reset
            </button>
            <input type="color" class="mx-1" v-model="props.options.color">
            <span>
                <p style="margin-bottom: 0">
                    Upload Image:
                </p>
                <input type="file" @change="(event) => onSetImage({ props, event, VueDrawingCanvas })">
            </span>
        </div>
    </div>
</template>

<script>
    import { defineComponent, reactive, ref, onUpdated } from "vue";
    import VueDrawingCanvas from "vue-drawing-canvas";
    import { initData, onSetImage } from "./canvas-drawing.logic";

    export default defineComponent({
    components: {
        VueDrawingCanvas,
    },
    props: {
        form: {},
        options: {},
        signatureFile: {},
        viewOnly: { default: false },
    },
    setup(props) {
        const data = reactive({ isInit: false });
        const VueDrawingCanvas = ref(null);
        onUpdated(() => {
            if (!data.isInit) {
                initData({ props, data, VueDrawingCanvas });
            }
        });
        return {
            props,
            data,
            onSetImage,
            VueDrawingCanvas
        };
    },
});
</script>